import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "api/baseurl";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast } from "react-toastify";
import { IconButton } from "@mui/material";
import Modal from "@mui/material/Modal";
import { Tooltip } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
// For your custom button component
import MDButton from "components/MDButton";
// Encryption and Decryption Functions
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import {
  Box,
  Grid,
  Card,
  Typography,
  Tabs,
  Tab,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { keyframes } from "@mui/system";
import { Button } from "@mui/material";
import AddoctorDocuments from "./AddDoctorDocuments";
import AddSpecilization from "./Addspecialization";
import AddCouncilName from "./AddCouncil";
import AddDoctorStudyDocuments from "./AddDoctorStudyDocumnets";
import defaultprofileimage from "../images/defaultprofile.jpg";
import Pagination from "@mui/material/Pagination";
import DownloadIcon from '@mui/icons-material/Download';
import { Checkbox,} from '@mui/material';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import MedicalAbstractBackground from "./MedicalAbstractBackground ";
// Encryption and Decryption Functions
function ViewDoctorProfile() {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [coordinator, setCoordinator] = useState(null);
  const [tab, setTab] = useState(0);
    const [selectedId, setSelectedId] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [opencertificateModal, setOpenCertificateModal] = useState(false);
        const [openspecializationModal, setOpenSpecializationModal] = useState(false);
    const [opencouncilModal, setOpenCouncilModal] = useState(false);
    const [deleteSpecialModal, setDeleteSpecialModal] = useState(false);
     const [deleteCouncilModal, setDeleteCouncilModal] = useState(false); 
     const [currentNotePage, setCurrentNotePage] = useState(0);
     const [totalNotePages, setNoteTotalPages] = useState(0);
      const [progressNote, setProgressNote] = useState(null);
      const loginData = JSON.parse(localStorage.getItem("loginData"));
  const userid = loginData?.userid;
      const [selectedNotes, setSelectedNotes] = useState([]);

  const fetchCoordinator = async () => {
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;
      const response = await axios.get(`/api/doctorregistration/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        const decrypted = decryptBody(response.data, secretKey);
        setCoordinator(decrypted ||[]);
      }
    } catch (err) {
      console.error("Error fetching coordinator:", err);
    } finally {
      setLoading(false);
    }
  };

  

  const fetchProgressNote = async (pageNumber = 1) => {
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;
      const response = await axios.get(`/api/doctornotes/ccid/${userid}/doctorid/${id}`, {
        params: { page: Math.max(0, pageNumber - 1) },    
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

      if (response.status === 200) {
        const decrypted = decryptBody(response.data, secretKey);
        console.log("test note");
        console.log(response.data);
        setProgressNote(decrypted || []);
       
         setCurrentNotePage(decrypted.number + 1);
          setNoteTotalPages(decrypted.totalPages);
      }
    } catch (err) {
      console.error("Error fetching coordinator:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCoordinator();
    fetchProgressNote();
  }, [id]);
const handleSelectNote = (id) => {
  setSelectedNotes((prev) =>
    prev.includes(id) ? prev.filter((n) => n !== id) : [...prev, id]
  );
};
  const handleNotePageChange = (_, pageNumber) => {
  setCurrentNotePage(pageNumber);
  fetchProgressNote(pageNumber);   // <-- ADD THIS
};
 const handleDownloadSelected = async (selectedNoteIds) => {
  if (!selectedNoteIds?.length || !progressNote?.content) return;

  // Map IDs to full note objects
  const notesToDownload = progressNote.content.filter(doc =>
    selectedNoteIds.includes(doc.id)
  );

  if (!notesToDownload.length) return;

  try {
    const doc = new jsPDF('p', 'mm', 'a4');
    const container = document.createElement('div');
    container.style.width = "210mm";
    container.style.padding = "15px";
    container.style.background = "#fff";
    container.style.color = "#000";
    container.style.fontFamily = "Times New Roman, serif";
    container.style.position = "fixed";
    container.style.left = "-9999px";
    document.body.appendChild(container);

    // ===== HEADER =====
    const headerDiv = document.createElement('div');
    headerDiv.style.display = "flex";
    headerDiv.style.alignItems = "flex-start";
    headerDiv.style.marginBottom = "20px";

    const img = document.createElement('img');
    img.src = coordinator?.image
      ? `data:image/jpeg;base64,${coordinator.image}`
      : defaultprofileimage;
    img.style.width = "150px";
    img.style.height = "150px";
    img.style.borderRadius = "50%";
    img.style.marginRight = "30px";
    headerDiv.appendChild(img);

    const middleDiv = document.createElement('div');
    middleDiv.style.flex = "2";
    middleDiv.style.lineHeight = "1.8";
    middleDiv.style.display = "flex";
    middleDiv.style.flexDirection = "column";
    middleDiv.innerHTML = `
      <span style="font-size:28px; font-weight:bold">${coordinator.firstname} ${coordinator.lastname}</span>
      <span style="font-size:18px;">Email: ${coordinator.email || "N/A"}</span>
      <span style="font-size:18px;">Phone: ${coordinator.phoneNumber || "N/A"}</span>
      <span style="font-size:18px;">Emergency: ${coordinator.emergencyPhoneNumber || "N/A"}</span>
      <span style="font-size:18px;">Doctor Type: ${coordinator.doctorType || "N/A"}</span>
      <span style="font-size:18px;">Address: ${[coordinator.address, coordinator.address1, coordinator.city, coordinator.state, coordinator.country].filter(Boolean).join(", ")} ${coordinator.pin ? `- ${coordinator.pin}` : ""}</span>
    `;
    headerDiv.appendChild(middleDiv);

    const rightDiv = document.createElement('div');
    rightDiv.style.flex = "1";
    rightDiv.style.lineHeight = "1.8";
    rightDiv.style.display = "flex";
    rightDiv.style.flexDirection = "column";
    rightDiv.innerHTML = `
      <span style="font-size:18px;">Age: ${coordinator.age || "N/A"}</span>
      <span style="font-size:18px;">DOB: ${coordinator.dob || "N/A"}</span>
      <span style="font-size:18px;">Gender: ${coordinator.gender || "N/A"}</span>
      <span style="font-size:18px;">Marital Status: ${coordinator.martialStatus || "N/A"}</span>
    `;
    headerDiv.appendChild(rightDiv);

    container.appendChild(headerDiv);

    const hr = document.createElement('hr');
    hr.style.border = "1px solid #000";
    hr.style.margin = "20px 0";
    container.appendChild(hr);

    // ===== Add selected progress notes one below the other =====
    notesToDownload.forEach((note) => {
      const noteDiv = document.createElement('div');
      noteDiv.style.fontSize = "18px";
      noteDiv.style.marginBottom = "20px";
      noteDiv.innerHTML = `
        <strong>Progress Note (Version ${note.version || "N/A"}):</strong><br/>
        ${note.notes || "No notes available"}<br/>
        <small>Date & Time: ${note.createdTime ? formatISTDateTimePretty(note.createdTime) : "N/A"}</small>
      `;
      container.appendChild(noteDiv);
    });

    const canvas = await html2canvas(container, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const pdfWidth = 190;
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    doc.addImage(imgData, "PNG", 10, 10, pdfWidth, pdfHeight);
    doc.save(`${coordinator.firstname}_${coordinator.lastname}_ProgressNotes.pdf`);

    document.body.removeChild(container);
  } catch (err) {
    console.error("PDF download error:", err);
    alert("Failed to generate PDF. Check console for details.");
  }
};



const handleDownloadPDF = async (selectedNote) => {
    try {
      const doc = new jsPDF('p', 'mm', 'a4');
  
      const container = document.createElement('div');
      container.style.width = "210mm";
      container.style.padding = "15px";
      container.style.background = "#fff";
      container.style.color = "#000";
      container.style.fontFamily = "Times New Roman, serif";
      container.style.position = "fixed";
      container.style.left = "-9999px";
      document.body.appendChild(container);
  
      // ===== HEADER =====
      const headerDiv = document.createElement('div');
      headerDiv.style.display = "flex";
      headerDiv.style.alignItems = "flex-start";
      headerDiv.style.marginBottom = "20px";
  
      // Left: Profile Photo
      const img = document.createElement('img');
      img.src = coordinator?.image ? `data:image/jpeg;base64,${coordinator.image}` : defaultprofileimage;
      img.style.width = "150px"; 
      img.style.height = "150px";
      img.style.borderRadius = "50%";
      img.style.marginRight = "30px";
      headerDiv.appendChild(img);
  
      // Middle: Name + Contact + Doctor Type + Address
      const middleDiv = document.createElement('div');
      middleDiv.style.flex = "2";
      middleDiv.style.lineHeight = "1.8";
      middleDiv.style.display = "flex";
      middleDiv.style.flexDirection = "column";
      middleDiv.style.justifyContent = "flex-start"; 
      middleDiv.innerHTML = `
        <span style="font-size:28px; font-weight:bold">${coordinator.firstname} ${coordinator.lastname}</span>
        <span style="font-size:18px;">Email: ${coordinator.email || ""}</span>
        <span style="font-size:18px;">Phone: ${coordinator.phonecountrycode || ""} ${coordinator.phoneNumber || ""}</span>
        <span style="font-size:18px;">Emergency: ${coordinator.emergencycountrycode || ""} ${coordinator.emergencyPhoneNumber || ""}</span>
        <span style="font-size:18px;">Doctor Type: ${coordinator.doctorType || ""}</span>
        <span style="font-size:18px;">Address: ${[coordinator.address, coordinator.address1, coordinator.city, coordinator.state, coordinator.country].filter(Boolean).join(", ")} ${coordinator.pin ? `- ${coordinator.pin}` : ""}</span>
      `;
      headerDiv.appendChild(middleDiv);
  
      // Right: Age, DOB, Gender, Marital Status
      const rightDiv = document.createElement('div');
      rightDiv.style.flex = "1";
      rightDiv.style.lineHeight = "1.8";
      rightDiv.style.display = "flex";
      rightDiv.style.flexDirection = "column";
      rightDiv.style.justifyContent = "flex-start";
      rightDiv.innerHTML = `
        <span style="font-size:18px;">Age: ${coordinator.age || ""}</span>
        <span style="font-size:18px;">DOB: ${coordinator.dob || ""}</span>
        <span style="font-size:18px;">Gender: ${coordinator.gender || ""}</span>
        <span style="font-size:18px;">Marital Status: ${coordinator.martialStatus || ""}</span>
      `;
      headerDiv.appendChild(rightDiv);
  
      container.appendChild(headerDiv);
  
      // Horizontal line
      const hr = document.createElement('hr');
      hr.style.border = "1px solid #000";
      hr.style.margin = "20px 0";
      container.appendChild(hr);
  
      // ===== Selected Progress Note =====
      if (selectedNote) {
        const noteDiv = document.createElement('div');
        noteDiv.style.fontSize = "18px";
        noteDiv.style.marginBottom = "15px";
        noteDiv.innerHTML = `
          <strong>Progress Note (Version ${selectedNote.version}):</strong><br/>
          ${selectedNote.notes}<br/>
          <small>Date & Time: ${formatISTDateTimePretty(selectedNote.createdTime)}</small>
        `;
        container.appendChild(noteDiv);
      } else {
        const noNote = document.createElement('div');
        noNote.style.fontSize = "18px";
        noNote.innerText = "No progress note selected.";
        container.appendChild(noNote);
      }
  
      // Render PDF
      const canvas = await html2canvas(container, { scale: 2 });
      const imgData = canvas.toDataURL("image/png");
  
      const pdfWidth = 190;
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
  
      doc.addImage(imgData, "PNG", 10, 10, pdfWidth, pdfHeight);
      doc.save(`${coordinator.firstname}_${coordinator.lastname}_ProgressNote.pdf`);
  
      document.body.removeChild(container);
    } catch (err) {
      console.error("PDF download error:", err);
      alert("Failed to generate PDF. Check console for details.");
    }
  };

  const spinAnimation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  `;
  const dotPositions = [
    { top: "5%", left: "50%" },
    { top: "20%", left: "80%" },
    { top: "50%", left: "95%" },
    { top: "80%", left: "80%" },
    { top: "95%", left: "50%" },
    { top: "80%", left: "20%" },
    { top: "50%", left: "5%" },
    { top: "20%", left: "20%" },
  ];

  if (loading) {
    return (
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          zIndex: 9999,
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: 80,
            height: 80,
            animation: `${spinAnimation} 1.5s linear infinite`,
          }}
        >
          {dotPositions.map((pos, index) => (
            <Box
              key={index}
              sx={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                backgroundColor: "#1A237E",
                position: "absolute",
                ...pos,
              }}
            />
          ))}
        </Box>
      </Box>
    );
  }
const HandleCertificateModal = (id) => {
  setSelectedId(id);
  setOpenCertificateModal(true);
};
const handleClosecerrificateModal = () => {
  setOpenCertificateModal(false);
  setSelectedId(null);
};
const HandleOpenCouncilModal = (id) => {
  setSelectedId(id);
  setOpenCouncilModal(true);
};
const handleCloseCouncilModal = () => {
  setOpenCouncilModal(false);
  setSelectedId(null);
};
const HandleOpenSpecializationModal = (id) => {
  setSelectedId(id);
  setOpenSpecializationModal(true);
};
const handleCloseSpecializationModal = () => {
  setOpenSpecializationModal(false);
  setSelectedId(null);
};
 const handleOpenDeleteModal = (id) => {
      setSelectedId(id);
      setDeleteModal(true);
    };

const handleOpenDeleteSpecialiModal = (id) => {
      setSelectedId(id);
      setDeleteSpecialModal(true);
    };

const handleOpenDeleteCouncilModal = (id) => {
      setSelectedId(id);
      setDeleteCouncilModal(true);
    };


    const handleDelete = async (e) => {
      e.preventDefault();
      setLoading(true);
      try {
        const secretKey = await fetchSecretKey();
        const token = JSON.parse(localStorage.getItem("loginData"))?.token;
    
        const encryptedData = encryptBody({ id: selectedId }, secretKey);
    
        const response = await axios.post("/api/doctordocuments/delete", encryptedData, {
          headers: { "Content-Type": "text/plain", Authorization: `Bearer ${token}` },
        });
    
        if (response.status === 200) {
          const decryptedResponse = decryptBody(response.data, secretKey);
          if (!decryptedResponse || !decryptedResponse.id) {
            throw new Error("Decryption failed or invalid response.");
          }
    
          toast.success(decryptedResponse.message || "Doctor Documents deleted successfully!");
    
          setDeleteModal(false); 
          fetchCoordinator();
        }
      } catch (error) {
        toast.error(error.message || "Failed to delete Doctor Documents.");
      } finally {
        setLoading(false);
      }
    };

     const handleSpecializationDelete = async (e) => {
      e.preventDefault();
      setLoading(true);
      try {
        const secretKey = await fetchSecretKey();
        const token = JSON.parse(localStorage.getItem("loginData"))?.token;
    
        const encryptedData = encryptBody({ id: selectedId }, secretKey);
    
        const response = await axios.post("/api/doctorspecialization/delete", encryptedData, {
          headers: { "Content-Type": "text/plain", Authorization: `Bearer ${token}` },
        });
    
        if (response.status === 200) {
          const decryptedResponse = decryptBody(response.data, secretKey);
          if (!decryptedResponse || !decryptedResponse.id) {
            throw new Error("Decryption failed or invalid response.");
          }
    
          toast.success(decryptedResponse.message || "Doctor Specializtion deleted successfully!");
    
          setDeleteSpecialModal(false); 
          fetchCoordinator();
        }
      } catch (error) {
        toast.error(error.message || "Failed to delete Doctor Documents.");
      } finally {
        setLoading(false);
      }
    };

     const handleCouncilDelete = async (e) => {
      e.preventDefault();
      setLoading(true);
      try {
        const secretKey = await fetchSecretKey();
        const token = JSON.parse(localStorage.getItem("loginData"))?.token;
    
        const encryptedData = encryptBody({ id: selectedId }, secretKey);
    
        const response = await axios.post("/api/doctorcounsilnames/delete", encryptedData, {
          headers: { "Content-Type": "text/plain", Authorization: `Bearer ${token}` },
        });
    
        if (response.status === 200) {
          const decryptedResponse = decryptBody(response.data, secretKey);
          if (!decryptedResponse || !decryptedResponse.id) {
            throw new Error("Decryption failed or invalid response.");
          }
    
          toast.success(decryptedResponse.message || "Doctor Council Name deleted successfully!");
    
          setDeleteCouncilModal(false); 
          fetchCoordinator();
        }
      } catch (error) {
        toast.error(error.message || "Failed to delete Doctor Documents.");
      } finally {
        setLoading(false);
      }
    };

    const formatISTDateTimePretty = (dateString) => {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");

  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const month = monthNames[date.getMonth()];

  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12 || 12; // 0 → 12 for 12-hour format

  return `${day} ${month} ${year}, ${hours}:${minutes} ${ampm}`;
};

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MedicalAbstractBackground/>
    <Card sx={{ p: 3, mt: 3 }}>
  {coordinator ? (
    <Grid container spacing={3}>
      {/* Left: Profile Image */}
      <Grid item xs={12} md={3} textAlign="center">
        <img
          src={ coordinator.image ? `data:image/jpeg;base64,${coordinator.image}`: defaultprofileimage}
          alt={coordinator.imageMeta || "Profile"}
          style={{ width: 150, height: 150, borderRadius: "50%" }}
        />
      
      </Grid>

      {/* Middle: Basic Info */}
      <Grid item xs={12} md={5}>
        <Typography variant="h5" sx={{ fontWeight: "bold", mb: 1 }}>
          {coordinator.firstname} {coordinator.lastname}
        </Typography>
        <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>Email:</strong> {coordinator.email}
        </Typography>
<Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>NMC Registered Number:</strong> {coordinator.nmcRegisteredNumber}
        </Typography><Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>Year of Registration:</strong> {coordinator.yearOfRegistration}
        </Typography><Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>Verification Status:</strong> {coordinator.verificationstatus}
        </Typography>
        <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>Phone Number:</strong> {coordinator.phonecountrycode} {coordinator.phoneNumber}
        </Typography>
      
      <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
  <strong>Address:</strong>{" "}
  {[coordinator.address, coordinator.address1, coordinator.city, coordinator.state, coordinator.country]
    .filter(Boolean)
    .join(", ")}
  {coordinator.pin ? ` - ${coordinator.pin}` : ""}
</Typography>
        
      </Grid>

      {/* Right: More Info */}
      <Grid item xs={12} md={4}  sx={{ mt: 4.2 }}>
          <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>Doctor Type:</strong> {coordinator.doctorType}
        </Typography>
        <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>Age:</strong> {coordinator.age}
        </Typography>
        <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>Marital Status:</strong> {coordinator.martialStatus}
        </Typography>
        <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>DOB:</strong> {coordinator.dob}
        </Typography>
        <Typography sx={{ fontSize: "14px" }}>
          <strong>Gender:</strong> {coordinator.gender}
        </Typography>
       <Box sx={{ mt: 0.5 }}>
  {coordinator?.hospitals?.map((hospital, index) => (
    <Typography
      key={hospital.id}
      sx={{
        fontSize: "14px",
        lineHeight: 1.6,
        color: "#1A237E",
      }}
    >
      <strong>Hospital Address {index + 1}:</strong>{" "}
      {hospital.name} – {hospital.addressLine1}
      {hospital.addressLine2 && `, ${hospital.addressLine2}`}
    </Typography>
  ))}
</Box>

      </Grid>
    </Grid>
  ) : (
    <Typography
      sx={{
        textAlign: "center",
        fontWeight: "bold",
        fontSize: "16px",
        color: "gray",
        my: 2,
      }}
    >
      No Data Available
    </Typography>
  )}

        {/* Tabs Section */}
        <Box sx={{ mt: 4 }}>
        <Tabs
  value={tab}
  onChange={(e, newVal) => setTab(newVal)}
  variant="scrollable"
  scrollButtons="auto"
  TabIndicatorProps={{
    style: {
      backgroundColor: "#1A237E", // elegant blue underline
      height: "3px",
      borderRadius: "2px",
    },
  }}
  sx={{
    backgroundColor: "#fff", // clean white bg
    borderBottom: "1px solid #e0e0e0",
    "& .MuiTab-root": {
      fontWeight: 500,
      fontSize: "16px",
      textTransform: "none",
      color: "#666",
      minHeight: "48px",
      padding: "10px 20px",
      transition: "all 0.3s ease",
    },
    "& .Mui-selected": {
      color: "#1A237E", // professional blue
      fontWeight: 600,
    },
    "& .MuiTab-root:hover": {
      color: "#1A237E",
      backgroundColor: "rgba(25, 118, 210, 0.08)", // light hover
      borderRadius: "6px 6px 0 0",
    },
  }}
>
<Tab label="Specialization & Council Names" />

  <Tab label="Demographic Certificate" />
  <Tab label="Qualification Certificate" />
  <Tab label="Progress Notes" />
</Tabs>

<br/>

{tab === 0 && (
      <>
<Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mb: 2 }}>
      <MDButton
        variant="outlined"
        
        
  sx={{
                         textTransform: "none",
                         color: "#1A237E",
                         borderColor: "#1A237E",
                         backgroundColor: "transparent",
                         height: 40,
                           mt: 1,
                         "&:hover": {
                           backgroundColor: "#f0f0f0",
                           borderColor: "#1A237E",
                         },
                         "&:focus": {
                           outline: "none",
                         },
                       }}       onClick={() => HandleOpenSpecializationModal(coordinator.id)}
      >
        Add Specialization
      </MDButton>

      <MDButton
        variant="outlined"
  sx={{
                         textTransform: "none",
                         color: "#1A237E",
                         borderColor: "#1A237E",
                         backgroundColor: "transparent",
                         height: 40,
                           mt: 1,
                         "&:hover": {
                           backgroundColor: "#f0f0f0",
                           borderColor: "#1A237E",
                         },
                         "&:focus": {
                           outline: "none",
                         },
                       }}       onClick={() => HandleOpenCouncilModal(coordinator.id)}
      >
        Add Council
      </MDButton>
    </Box>
  <Box sx={{ mt: 2, display: "flex", gap: 2 }}>

    
    {/* ==== Specializations Table ==== */}
    <Table sx={{ border: "1px solid #ddd", flex: 1 }}>
      <TableHead>
        <TableRow sx={{ backgroundColor: "#1A237E" }}>
          <TableCell
            sx={{
              color: "#fff",
                fontWeight: "600", 
              border: "1px solid #ddd",
              textAlign: "center",
              padding: "11px 179px",
              color: "#fff",
              fontSize: "15px",
            //  minWidth: "400px",   

            }}
          >
            Specializations
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {coordinator?.specializations?.length > 0 ? (
          coordinator.specializations.map((spec, idx) => (
            <TableRow key={`spec-${idx}`}>
              <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
                {spec.doctorspecialization}  
                 <IconButton
                                                         color="default"
                                                         
                                                         onClick={(event) => {
                                                          event.stopPropagation();
                                                          handleOpenDeleteSpecialiModal(spec.id);
                                                        }}                 >
                                                         <DeleteIcon />
                                                       </IconButton>
              </TableCell>
              

            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell
              align="center"
              sx={{ border: "1px solid #ddd", color: "gray", fontStyle: "italic" }}
            >
              No Specializations Available
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>

    {/* ==== Councils Table ==== */}
    <Table sx={{ border: "1px solid #ddd", flex: 1 }}>
      <TableHead>
        <TableRow sx={{ backgroundColor: "#1A237E"}}>
          <TableCell
            sx={{
             color: "#fff",
                fontWeight: "600", 
              border: "1px solid #ddd",
              textAlign: "center",
              padding: "11px 178px",
              color: "#fff",
              fontSize: "15px",
              // minWidth: "400px",   
            }}
          >
            Council Names
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {coordinator?.councilNames?.length > 0 ? (
          coordinator.councilNames.map((council, idx) => (
            <TableRow key={`council-${idx}`}>
              <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
                {council.doctorCounsilNames}

                <IconButton
                                                         color="default"
                                                         
                                                         onClick={(event) => {
                                                          event.stopPropagation();
                                                          handleOpenDeleteCouncilModal(council.id);
                                                        }}                 >
                                                         <DeleteIcon />
                                                       </IconButton>
              </TableCell>
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell
              align="center"
              sx={{ border: "1px solid #ddd", color: "gray", fontStyle: "italic" }}
            >
              No Council Names Available
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  </Box>
  </>
)}


       {tab === 1 && (
  <Box sx={{ mt: 2 }}>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
      <Button
        variant="outlined"
         sx={{
                         textTransform: "none",
                         color: "#1A237E",
                         borderColor: "#1A237E",
                         backgroundColor: "transparent",
                         height: 40,
                           mt: 1,
                         "&:hover": {
                           backgroundColor: "#f0f0f0",
                           borderColor: "#1A237E",
                         },
                         "&:focus": {
                           outline: "none",
                         },
                       }}
        onClick={() => HandleCertificateModal(coordinator?.id)}
      >
        + Add Certificate
      </Button>
    </Box>
    <Table sx={{ border: "1px solid #ddd" }}>
      <TableHead>
        <TableRow sx={{ backgroundColor: "#1A237E" }}>
          {["Document Name",  "Date of Upload", "Action"].map((header, index) => (
            <TableCell
              key={index}
              sx={{
                 color: "#fff",
                fontWeight: "600", 
                border: "1px solid #ddd",
                textAlign: "center",
                padding: "12px",
  minWidth: index === 0 ? "315px" : "195px",
width: index === 0 ? "315px" : "400px",

                whiteSpace: "nowrap",  // Prevent breaking into multiple lines
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {header}
            </TableCell>
          ))}
        </TableRow>
      <TableBody>
        {coordinator?.documents?.filter(doc => doc.documentname !== "Study Certificate").length > 0 ? (
          coordinator.documents
            .filter(doc => doc.documentname !== "Study Certificate")
            .map((doc, idx) => (
              <TableRow key={idx}>
                <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
                  {doc.documentname}
                </TableCell>
               
                <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
                  {doc.dateofupload}
                </TableCell>
                <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
                    <IconButton
                                                         color="default"
                                                         
                                                         onClick={(event) => {
                                                          event.stopPropagation();
                                                          handleOpenDeleteModal(doc.id);
                                                        }}                 >
                                                         <DeleteIcon />
                                                       </IconButton>
           {doc.image ? (
  <Tooltip title="View Document">
   <IconButton
    sx={{
      "&:hover": {
        backgroundColor: "rgba(0,0,0,0.05)",
      },
    }}
    onClick={() => {
      // Validate document data
      if (!doc?.image) {
        alert('No document data available to preview');
        return;
      }

      try {
        // Detect file type from base64 signature since documenttype is null
        const base64Start = doc.image.substring(0, 50);
        
        // PDF starts with "JVBERi0x" (base64 of "%PDF")
        const isPDF = base64Start.startsWith('JVBERi0x') || 
                      doc.documenttype === "application/pdf" || 
                      doc.documenttype === "pdf" ||
                      doc.documentname?.toLowerCase().endsWith('.pdf');
        
        // PNG starts with "iVBORw0KGgo"
        const isPNG = base64Start.startsWith('iVBORw0KGgo');
        
        // JPEG starts with "/9j/"
        const isJPEG = base64Start.startsWith('/9j/');
        
        console.log('Detected types - PDF:', isPDF, 'PNG:', isPNG, 'JPEG:', isJPEG);

        if (isPDF) {
          // PDF handling with blob
          const binaryString = atob(doc.image);
          const bytes = new Uint8Array(binaryString.length);
          for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }
          const blob = new Blob([bytes], { type: 'application/pdf' });
          console.log('PDF Blob size:', blob.size, 'bytes');
          
          const fileURL = URL.createObjectURL(blob);
          const pdfWindow = window.open(fileURL, '_blank');
          
          if (!pdfWindow) {
            alert('Popups are blocked. Please enable popups for this site.');
          }
          
          setTimeout(() => URL.revokeObjectURL(fileURL), 120000);
        } else {
          // Image handling - auto-detect MIME type
          let mimeType;
          if (isPNG) {
            mimeType = 'image/png';
          } else if (isJPEG) {
            mimeType = 'image/jpeg';
          } else {
            // Default to png if unknown
            mimeType = 'image/png';
          }
          
          console.log('Using MIME type:', mimeType);
          
          const fileURL = `data:${mimeType};base64,${doc.image}`;
          
          const newWindow = window.open('', '_blank');
          if (newWindow) {
            newWindow.document.write(`
              <!DOCTYPE html>
              <html>
                <head>
                  <title>Image Preview - ${doc.documentname || 'Document'}</title>
                  <style>
                    body { 
                      margin: 0; 
                      display: flex; 
                      justify-content: center; 
                      align-items: center; 
                      min-height: 100vh; 
                      background: #2c3e50;
                    }
                    img { 
                      max-width: 95%; 
                      max-height: 95vh; 
                      box-shadow: 0 4px 20px rgba(0,0,0,0.5);
                      border-radius: 4px;
                    }
                    .error {
                      color: white;
                      text-align: center;
                      font-family: Arial, sans-serif;
                      padding: 20px;
                    }
                  </style>
                </head>
                <body>
                  <img 
                    src="${fileURL}" 
                    alt="${doc.documentname || 'Document'}"
                    onload="console.log('Image loaded successfully')"
                    onerror="this.style.display='none'; document.body.innerHTML='<div class=error><h2>Failed to load image</h2><p>Please try downloading the file instead.</p></div>'"
                  />
                </body>
              </html>
            `);
            newWindow.document.close();
            newWindow.focus();
          } else {
            alert('Popups are blocked. Please enable popups for this site.');
          }
        }
      } catch (error) {
        console.error('Error opening document:', error);
        alert('Error opening document: ' + error.message);
      }
    }}
  >
    <VisibilityIcon />
  </IconButton>
  </Tooltip>
) : (
  "—"
)}
                </TableCell>
              </TableRow>
            ))
        ) : (
          <TableRow>
            <TableCell
              colSpan={4}
              align="center"
              sx={{ border: "1px solid #ddd", color: "gray", fontStyle: "italic" }}
            >
              No Data Available
            </TableCell>
          </TableRow>
        )}
      </TableBody>
                  </TableHead>

    </Table>
  </Box>
)}

{tab === 2 && (
  <Box sx={{ mt: 2 }}>
    <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
      <Button
        variant="outlined"
         sx={{
                         textTransform: "none",
                         color: "#1A237E",
                         borderColor: "#1A237E",
                         backgroundColor: "transparent",
                         height: 40,
                           mt: 1,
                         "&:hover": {
                           backgroundColor: "#f0f0f0",
                           borderColor: "#1A237E",
                         },
                         "&:focus": {
                           outline: "none",
                         },
                       }}
        onClick={() => HandleCertificateModal(coordinator?.id)}
      >
        + Add Certificate
      </Button>
    </Box>
    <Table sx={{ border: "1px solid #ddd" }}>
      <TableHead>
        <TableRow sx={{ backgroundColor: "#1A237E"}}>
          {["Document Name",  "Date of Upload", "Action"].map((header, index) => (
            <TableCell
              key={index}
              sx={{
                color: "#fff",
                fontWeight: "600", 
                border: "1px solid #ddd",
                textAlign: "center",
                padding: "12px",
  minWidth: index === 0 ? "315px" : "195px",
width: index === 0 ? "315px" : "400px",

                whiteSpace: "nowrap",  // Prevent breaking into multiple lines
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {header}
            </TableCell>
          ))}
        </TableRow>
      <TableBody>
        {coordinator?.documents?.filter(doc => doc.documentname === "Study Certificate").length > 0 ? (
          coordinator.documents
            .filter(doc => doc.documentname === "Study Certificate")
            .map((doc, idx) => (
              <TableRow key={idx}>
                <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
                  {doc.documentname}
                </TableCell>
              
                <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
                  {doc.dateofupload}
                </TableCell>
                <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
                    <IconButton
                                                         color="default"
                                                         
                                                         onClick={(event) => {
                                                          event.stopPropagation();
                                                          handleOpenDeleteModal(doc.id);
                                                        }}                 >
                                                         <DeleteIcon />
                                                       </IconButton>
                 {doc.image ? (
                   <Tooltip title="View Document">
                     <IconButton
                       sx={{
                         "&:hover": {
                           backgroundColor: "rgba(0,0,0,0.05)", // subtle hover effect
                         },
                       }}
                       onClick={() => {
                         const fileURL = `data:image/${doc.documenttype};base64,${doc.image}`;
                         const newWindow = window.open();
                         newWindow.document.write(
                           `<iframe src="${fileURL}" width="100%" height="100%" style="border:none;"></iframe>`
                         );
                       }}
                     >
                       <VisibilityIcon />
                     </IconButton>
                   </Tooltip>
                 ) : (
                   "—"
                 )}
                </TableCell>
              </TableRow>
            ))
        ) : (
          <TableRow>
            <TableCell
              colSpan={4}
              align="center"
              sx={{ border: "1px solid #ddd", color: "gray", fontStyle: "italic" }}
            >
              No Data Available
            </TableCell>
          </TableRow>
        )}
      </TableBody>
            </TableHead>

    </Table>
  </Box>
)}

{tab === 3 && (
  <Box sx={{ mt: 2 }}>
     <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
      <Button
      variant="outlined"
      onClick={() => handleDownloadSelected(selectedNotes)}
      disabled={selectedNotes.length === 0}
     sx={{
                         textTransform: "none",
                         color: "#1A237E",
                         borderColor: "#1A237E",
                         backgroundColor: "transparent",
                         height: 40,
                           mt: 1,
                         "&:hover": {
                           backgroundColor: "#f0f0f0",
                           borderColor: "#1A237E",
                         },
                         "&:focus": {
                           outline: "none",
                         },
                       }}

                           >
      Generate PDF
    </Button>
    
    </Box>
    <Table sx={{ border: "1px solid #ddd" }}>
      <TableHead>
        <TableRow sx={{ backgroundColor:"#1A237E" }}>
          {["Select","Version","Progress Notes",  "Date and Time","Download"].map((header, index) => (
            <TableCell
              key={index}
              sx={{
                  color: "#fff",
                fontWeight: "600",
                border: "1px solid #ddd",
                textAlign: "center",
                padding: "12px",
  minWidth: index === 0 ? "28px" : "195px",
width: index === 0 ? "315px" : "400px",

                whiteSpace: "nowrap",  // Prevent breaking into multiple lines
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {header}
            </TableCell>
          ))}
        </TableRow>
    <TableBody>
     {progressNote?.content?.length > 0 ? (
       progressNote.content.map((doc, idx) => (
<TableRow key={idx}>
          <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
                <Checkbox
                  checked={selectedNotes.includes(doc.id)}
                  onChange={() => handleSelectNote(doc.id)}
                />
                {/* {doc.version} */}
              </TableCell>          <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>{doc.version}</TableCell>
           <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>{doc.notes}</TableCell>
           <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>{formatISTDateTimePretty(doc.createdTime)}</TableCell>
            <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
                  <IconButton onClick={() => handleDownloadPDF(doc)}>
                    <DownloadIcon />
                  </IconButton>
                </TableCell>
         </TableRow>
       ))
     ) : (
       <TableRow>
         <TableCell
           colSpan={4}
           align="center"
           sx={{ border: "1px solid #ddd", color: "gray", fontStyle: "italic" }}
         >
           No Data Available
         </TableCell>
       </TableRow>
     )}
   </TableBody>
            </TableHead>
        <Box mt={2} display="flex" justifyContent="center">
                <Pagination
                  count={totalNotePages}
                  page={currentNotePage}
                  onChange={handleNotePageChange}
                  color="success"
                   sx={{
          "& .MuiPaginationItem-root": {
            borderRadius: "4px",
            color: "#1A237E",          // Text color
            borderColor: "#1A237E",    // Border color if outlined
          },
          "& .MuiPaginationItem-root.Mui-selected": {
            backgroundColor: "#1A237E", // Selected background
            color: "#fff",                 // Selected text color
          },
          "& .MuiPaginationItem-root:hover": {
            backgroundColor: "#1A237E", // Slight hover effect
          },
        }}
                />
              </Box>
              
    </Table>
    
  </Box>
)}

        </Box>
      </Card>

      <Modal open={deleteModal} onClose={() => setDeleteModal(false)} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Card sx={{ padding: 3, width: "400px", textAlign: "center" }}>
                      <Typography variant="h6" gutterBottom>Are you sure you want to delete this Document</Typography>
                      <MDButton onClick={handleDelete} color="error"  sx={{ minWidth: "60px", marginRight: "5px", padding: "5px 10px" }}>Yes</MDButton>&emsp;
                      <MDButton color="secondary" onClick={() => setDeleteModal(false)} sx={{ minWidth: "30px" }}>Cancel</MDButton>
                    </Card>
                  </Modal>

        <Modal open={deleteSpecialModal} onClose={() => setDeleteSpecialModal(false)} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Card sx={{ padding: 3, width: "400px", textAlign: "center" }}>
                      <Typography variant="h6" gutterBottom>Are you sure you want to delete this Specialization</Typography>
                      <MDButton onClick={handleSpecializationDelete} color="error"  sx={{ minWidth: "60px", marginRight: "5px", padding: "5px 10px" }}>Yes</MDButton>&emsp;
                      <MDButton color="secondary" onClick={() => setDeleteSpecialModal(false)} sx={{ minWidth: "30px" }}>Cancel</MDButton>
                    </Card>
                  </Modal>



        <Modal open={deleteCouncilModal} onClose={() => setDeleteCouncilModal(false)} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Card sx={{ padding: 3, width: "400px", textAlign: "center" }}>
                      <Typography variant="h6" gutterBottom>Are you sure you want to delete this Council Name</Typography>
                      <MDButton onClick={handleCouncilDelete} color="error"  sx={{ minWidth: "60px", marginRight: "5px", padding: "5px 10px" }}>Yes</MDButton>&emsp;
                      <MDButton color="secondary" onClick={() => setDeleteCouncilModal(false)} sx={{ minWidth: "30px" }}>Cancel</MDButton>
                    </Card>
                  </Modal>
 {opencertificateModal && tab === 1 && (
   <AddoctorDocuments
     isOpen={opencertificateModal}
     onRequestClose={handleClosecerrificateModal}
     id={selectedId}
        fetchCoordinator = { fetchCoordinator }
 
   />
 )}
 {opencertificateModal && tab === 2 && (
   <AddDoctorStudyDocuments
     isOpen={opencertificateModal}
     onRequestClose={handleClosecerrificateModal}
     id={selectedId}
     fetchCoordinator = { fetchCoordinator }
   />
 )}{opencouncilModal && (
  <AddCouncilName
    isOpen={opencouncilModal}
    onRequestClose={handleCloseCouncilModal}
    id={selectedId}
    fetchCoordinator = { fetchCoordinator }
  />
)}

{openspecializationModal && (
  <AddSpecilization
    isOpen={openspecializationModal}
    onRequestClose={handleCloseSpecializationModal}
    id={selectedId}
    fetchCoordinator = { fetchCoordinator }
  />
)}

    </DashboardLayout>
  );
}

export default ViewDoctorProfile;
